// extracted by mini-css-extract-plugin
export default {"toggle-button":"toggle-button_toggle-button__yUkQP","selected":"toggle-button_selected__mykqC","medium":"toggle-button_medium__GeOWG"};